import { getData as apiGetData } from 'api/Api'
import {
  setCount,
} from '../redux/userBlockers'

const fetchUserBlockerCount = () => async dispatch => {  
  const { Value } = await apiGetData('MyCardBlockersCount')

  dispatch(setCount({
    count: Value,
  }))
}

export default fetchUserBlockerCount
